/**
 * Centralised mapping: notification/email/push entity_type -> deep-link URL.
 * When `entity_id` is provided, builds a query param `?open=<id>` so the
 * target list page can scroll-to and highlight the row.
 *
 * Pages that consume this convention should read `?open=` from
 * `useSearchParams()` and call `useOpenRecord(id, testidPrefix)`.
 */
const ENTITY_BASE_PATHS = {
  calendar: "/admin/calendar",
  document: "/admin/documents",
  file: "/admin/files",
  task: "/admin/tasks",
  protocol: "/admin/protocols",
  contract: "/admin/contracts",
  subsidy: "/admin/subsidies",
  quote: "/admin/quotes",
  invoice: "/admin/invoices",
  invoices: "/admin/invoices",
  project: "/admin/projects",
  claim: "/admin/claims",
  service: "/admin/service",
  service_order: "/admin/service",
  rental: "/admin/rentals",
  customer: "/admin/customers",
  submission: "/admin/submissions",
  inquiry: "/admin/submissions",
  revision: "/admin/revize",
  installation: "/admin/installations",
};

const ENTITY_ID_QUERY_KEY = {
  task: "task",
  default: "open",
};

export function buildEntityLink(entityType, entityId) {
  if (!entityType) return null;
  const base = ENTITY_BASE_PATHS[entityType];
  if (!base) return null;
  if (!entityId) return base;
  const key = ENTITY_ID_QUERY_KEY[entityType] || ENTITY_ID_QUERY_KEY.default;
  return `${base}?${key}=${encodeURIComponent(entityId)}`;
}

export function getEntityBasePath(entityType) {
  return ENTITY_BASE_PATHS[entityType] || null;
}
